import { colors } from 'ui/theme/colors';
import { getColor } from '../../../utils';
import { SvgIcon, SvgIconProps } from '../../../SvgIcon';

export const WebPushSend24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.5 5.25C4.80964 5.25 4.25 5.80964 4.25 6.5V13C4.25 13.1381 4.36193 13.25 4.5 13.25H19C19.1381 13.25 19.25 13.1381 19.25 13V6.5C19.25 5.80964 18.6904 5.25 18 5.25H5.5ZM4.25 15C4.25 14.8619 4.36193 14.75 4.5 14.75H19C19.1381 14.75 19.25 14.8619 19.25 15C19.25 15.6904 18.6904 16.25 18 16.25H5.5C4.80964 16.25 4.25 15.6904 4.25 15ZM2.75 6.5C2.75 4.98122 3.98122 3.75 5.5 3.75H18C19.5188 3.75 20.75 4.98122 20.75 6.5V15C20.75 16.5188 19.5188 17.75 18 17.75H15.4555C15.301 17.75 15.1835 17.8887 15.2089 18.0411L15.413 19.2661C15.4331 19.3866 15.5374 19.475 15.6596 19.475H16.5C16.9142 19.475 17.25 19.8108 17.25 20.225C17.25 20.6392 16.9142 20.975 16.5 20.975H7.5C7.08579 20.975 6.75 20.6392 6.75 20.225C6.75 19.8108 7.08579 19.475 7.5 19.475H8.34038C8.46259 19.475 8.56689 19.3866 8.58698 19.2661L8.79114 18.0411C8.81654 17.8887 8.69903 17.75 8.54455 17.75H5.5C3.98122 17.75 2.75 16.5188 2.75 15V6.5ZM10.5721 17.75C10.4499 17.75 10.3456 17.8384 10.3255 17.9589L10.1214 19.1839C10.096 19.3363 10.2135 19.475 10.368 19.475H13.632C13.7865 19.475 13.904 19.3363 13.8786 19.1839L13.6745 17.9589C13.6544 17.8384 13.5501 17.75 13.4279 17.75H10.5721Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
